import { Component, OnInit } from '@angular/core';
import { debounceTime, distinctUntilChanged, map, first } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { UnidadeService } from 'src/app/services/http/unidade.service';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalJustificativaComponent } from 'src/app/app-components/modal-justificativa/modal-justificativa.component';
import { Router, ActivatedRoute } from '@angular/router';
import { UsuarioService } from 'src/app/services/http/usuario.service';
import { LoginService } from 'src/app/services/login.service';
import { UsuarioUnidade } from 'src/app/models/usuario-unidade';
import { Usuario } from 'src/app/models/usuario-login';
import { UserConfigsUtils } from 'src/app/utils/UserConfigsUtils';

@Component({
  selector: 'app-list-usuario',
  templateUrl: './list-usuario.component.html',
  styleUrls: ['./list-usuario.component.scss']
})
export class ListUsuarioComponent implements OnInit {
  usuario: Usuario;
  listaUsuarios = [];
  unidade: boolean;
  cliente: boolean;
  login = null;

  order = {
    id: '',
    nome: '',
    email: '',
    login: ''
  }

  unidadeSelecionada: any;
  uuidUnidade: any;
  listaUnidades = [];
  inputUnidadeFormat = (u) => u.nomeFantasia;
  pesquisaUnidade = (text: Observable<string>) =>
    text.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => this.listaUnidades.filter(
        c => c.nomeFantasia.toLowerCase().indexOf(term.toLowerCase()) > -1
      ).slice(0, 10))
    );

  first: number = 0;
  object: any = {};
  dynamicdownloadName: string = "Usuários"

  cols: any = [
    { field: 'id', header: '#' },
    { field: 'nome', header: 'Nome' },
    { field: 'email', header: 'E-mail' },
    { field: 'login', header: 'Login' }
  ];

  constructor(private loginService: LoginService, private route: Router, private activatedRoute: ActivatedRoute, private unidadeService: UnidadeService, private usuarioService: UsuarioService, private modalMsgService: ModalMsgService, private modalService: NgbModal) {
    this.loginService.getLogIn().pipe(first()).subscribe(u => this.usuario = u);
    this.unidadeService.getListaUnidadeNomeFantasia().then(r => this.listaUnidades = r);
    this.unidade = this.activatedRoute.snapshot.data['unidade'];
    if (!this.unidade)
      this.loginService.getLogIn().pipe(first()).subscribe(l => {
        this.login = l;
        this.uuidUnidade = this.login.unidade.uuid;
        this.getUsuarios();
      });
  }

  ngOnInit() {
  }

  addFiltroUnidade($event) {
    this.uuidUnidade = $event.item.uuid;
    this.getUsuarios();
  }

  getUsuarios() {
    this.usuarioService.listaUsuariosUnidade(this.uuidUnidade).then(u => this.listaUsuarios = u);
  }

  mudarStatusUsuario($event, u) {
    var statusAntes = u.status;
    const modalRef = this.modalService.open(ModalJustificativaComponent, { centered: true });
    modalRef.componentInstance.cabecalho = 'Alterar status do usuário';

    modalRef.result.then(justificativa => {
      if (justificativa) {
        u.status = $event;

        this.usuarioService.alterarStatusUsuario({
          ip: UserConfigsUtils?.getUserConfigsStorage()?.ip || "",
          ...u
        }, justificativa)
          .then(r => this.getUsuarios())
          .catch(e => this.modalMsgService.openDialog('Erro ao alterar usuario', '', 'danger'));
      } else {
        u.status = statusAntes;
        this.modalMsgService.openDialog('Erro ao alterar usuário',
          'Informe uma Justificativa para concluir a operação', 'danger');
      }
    }).catch(e => {
      u.status = statusAntes;
      this.modalMsgService.openDialog('Erro ao alterar usuário',
        'Informe uma Justificativa para concluir a operação', 'danger')
    });
  }

  removeFiltroUnidade() {
    this.unidadeSelecionada = '';
    this.listaUsuarios = [];
    this.uuidUnidade = null;
  }

  editarUsuario(usuario) {
    if(this.unidade) {
      this.route.navigate(['unidade','usuario','editar', usuario.uuid, this.uuidUnidade]);
    } else {
      this.route.navigate(['usuario', 'editar', usuario.uuid]);
    }
  }

  visualizarUsuario(usuario) {
    if(this.unidade) {
      this.route.navigate(['unidade','usuario','visualizar', usuario.uuid, this.uuidUnidade]);
    } else {
      this.route.navigate(['usuario', 'visualizar', usuario.uuid]);
    }
  }

  removerUsuario(u) {
    const modalRef = this.modalService.open(ModalJustificativaComponent, { centered: true });
    modalRef.componentInstance.cabecalho = 'Remover usuario';
    modalRef.result.then(justificativa => {
      if (justificativa) {
        this.usuarioService.deletarUsuarioUnidade({
          ip: UserConfigsUtils?.getUserConfigsStorage()?.ip || "",
          ...u
        }, justificativa)
          .then(r => this.getUsuarios())
          .catch(e => this.modalMsgService.openDialog('Erro ao remover usuario', '', 'danger'));
      } else {
        this.modalMsgService.openDialog('Erro ao remover usuario',
          'Informe uma Justificativa para concluir a operação', 'danger');
      }
    }).catch(e => this.modalMsgService.openDialog('Erro ao remover usuario',
      'Informe uma Justificativa para concluir a operação', 'danger'));

  }

  adicionarUsuario() {
    if (this.unidade) {
      this.route.navigate(['unidade', 'usuario', 'adicionar', this.uuidUnidade]);
    } else {
      this.route.navigate(['usuario', 'adicionar']);
    }
  }

  alterarSenhaUsuario(usuario: UsuarioUnidade) {
    if (this.unidade) {
      this.route.navigate(['unidade', 'usuario', 'alterar-senha', usuario.uuid]);
    } else {
      this.route.navigate(['usuario', 'alterar-senha', usuario.uuid]);
    }
  }

  setOrder() {
    this.getUsuarios();
  }

}
